export enum AssessmentStatuses {
  Published,
  'Not published',
}
